import { ClientAccessSettings } from '@models/client.model';

export interface ClientDashboardFlags {
  /** The feed column (and everything that queries the feed). */
  showFeed: boolean;
  /** The Incidents triage pill and its count query. */
  showIncidents: boolean;
  /** The Invoices triage pill and its count query. */
  showInvoices: boolean;
}

const ALL_OFF: ClientDashboardFlags = {
  showFeed: false,
  showIncidents: false,
  showInvoices: false,
};

/**
 * Sprint 43, story-223. Which sections of the client home are on, derived from the CLIENT's
 * least-exposure checklist. `access` is `null` for an unlinked CLIENT (every key OFF).
 * Nothing but `activity` ever creates the feed column: `incidents` and `priceTotals` only refine
 * what a visible feed offers, so `priceTotals` ON with `activity` OFF is the same as all-OFF.
 * `invoicesFlag` is the deploy-time `INVOICES` env kill-switch.
 */
export const deriveClientDashboardFlags = (
  access: ClientAccessSettings | null | undefined,
  invoicesFlag: boolean,
): ClientDashboardFlags => {
  if (!access || !access.activity) return ALL_OFF;
  return {
    showFeed: true,
    showIncidents: Boolean(access.incidents),
    showInvoices: Boolean(access.priceTotals) && invoicesFlag,
  };
};
